export default "__VITE_ASSET__C_0AlZKS__"